import { useEffect } from 'react'
import { Spinner } from '@heroui/react'
import { StationPanelLinePhoto } from '../panels/StationPanelLinePhoto'
import { WindRoseHeader } from './shared/WindRoseHeader'
import { WindRoseTable } from './shared/WindRoseTable'
import { WindRoseChart } from './shared/WindRoseChart'
import { useMonthPeriodStore } from '../../store/useMonthPeriodStore'
import { useWindRoseStore } from '../../store/useWindRoseStore'
import { useWindRoseData, calcMonthFromTo } from '../../hooks/useWindRoseData'

export function MlyVitrRuziceView({ station }) {
  const { year, month, setYear, setMonth } = useMonthPeriodStore()
  const { vtype, intervals } = useWindRoseStore()

  // Měsíční růžice se počítá až nad kompletním měsícem — nejvyšší období je předchozí
  // měsíc. Store je sdílený s ostatními reporty, takže hodnotu sem srazíme.
  const now = new Date()
  const maxYear = now.getMonth() === 0 ? now.getFullYear() - 1 : now.getFullYear()
  const maxMonth = now.getMonth() === 0 ? 12 : now.getMonth()

  const isOverMax = year > maxYear || (year === maxYear && month > maxMonth)
  useEffect(() => {
    if (isOverMax) { setYear(maxYear); setMonth(maxMonth) }
  }, [isOverMax, maxYear, maxMonth, setYear, setMonth])

  const effYear = isOverMax ? maxYear : year
  const effMonth = isOverMax ? maxMonth : month

  const sid = String(effMonth).padStart(2, '0')
  const { data, loading, error } = useWindRoseData({
    ghId: station?.gh_id, year: effYear, stype: 'MONTH', sid, vtype, intervals,
  })

  const { from, to } = calcMonthFromTo(effYear, effMonth)

  return (
    <div className="flex flex-col h-full">
      <div className="p-4 border-b border-gray-200 bg-white flex flex-col gap-3">
        {station && <StationPanelLinePhoto station={station} />}
        <WindRoseHeader stype="MONTH" year={effYear} month={effMonth} onYearChange={setYear} onMonthChange={setMonth} />
      </div>

      <div className="flex-1 min-h-0 p-4 flex flex-col gap-4 overflow-auto">
        {loading && (
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Spinner size="sm" /> Načítání dat…
          </div>
        )}
        {error && <p className="text-red-500 text-sm">Chyba při načítání dat</p>}
        {!loading && !error && !data && (
          <p className="text-gray-500 text-sm">Pro toto období nejsou data k dispozici</p>
        )}
        {!loading && !error && data && (
          <>
            <WindRoseTable data={data} vtype={vtype} />
            <WindRoseChart station={station} stype="MONTH" from={from} to={to} vtype={vtype} intervals={intervals} />
          </>
        )}
      </div>
    </div>
  )
}
